import React, { useEffect, useState } from "react";
import menuIcon from "../../../assets/images/DeathModuleNew/Menu.png";
import { useDispatch, useSelector } from "react-redux";
import { setActivated } from "../../../redux/slices/loginSlice";
import { setAddClientButton } from "../../../redux/slices/financialAdvisorSlice";
import AddClientModal from "../../../components/styled-components/modal/addClientModal/AddClientModal";
import { Menu, Dropdown } from "antd";
import moment from "moment";
import "antd/dist/antd.css";
import "./ClientDetails.css";

const ClientDetails = ({ data, deleteClient }) => {
  const [accessableUsers, setAccessableUsers] = useState([]);
  const [isModalVisible, setModalVisible] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    username: "",
    email: "",
    phone: "",
    zipCode: "",
  });
  console.log("dd", data);

  const dispatch = useDispatch();
  const activated = useSelector(
    (state) => state.rootReducer.loginUser.activated
  );

  const isShowClientBtn = useSelector(
    (state) => state.rootReducer.financialAdvisor.showAddClientButton
  );
  const users =
    localStorage.getItem("delegateUsers") !== "undefined" &&
    JSON.parse(localStorage.getItem("delegateUsers"));

  useEffect(() => {
    const users =
      localStorage.getItem("delegateUsers") !== "undefined" &&
      JSON.parse(localStorage.getItem("delegateUsers"));
    setAccessableUsers(users);
  }, [activated]);

  const handleAccessClient = (clientData) => {
    // console.log("clientData", clientData);
    dispatch(setAddClientButton(false));

    clientData && handleClick(clientData.client.id);
    localStorage.setItem("accessId", clientData.client.id);

    if (!localStorage.getItem("duplicateRole")) {
      localStorage.setItem("duplicateRole", localStorage.getItem("role"));
    }

    localStorage.setItem("role", JSON.stringify("Financial Advisor Client"));
    localStorage.setItem("financialAccess", JSON.stringify(clientData));

    dispatch(setActivated(!activated));
  };

  const handleClick = (id) => {
    console.log("id", id);
    users &&
      users.map((item, index) => {
        if (id == item.client.id) {
          // console.log("here");
          item["Status"] = true;
          localStorage.setItem("delegateUsers", JSON.stringify(users));
        } else {
          item["Status"] = false;
        }
      });
  };

  return (
    <div className="clientDetailsCard">
      <div className="clientDetailsCardHeader">
        <div className="headerRow">
          <h1 className="clientDetailsHeading">Client Details</h1>
          <div className="headerActions">
            {data && data.client.id == localStorage.getItem("accessId") ? (
              <button className="accessClientBtn" onClick={() => {}}>
                Activated
              </button>
            ) : (
              <button
                className="accessClientBtn"
                onClick={() => handleAccessClient(data)}
              >
                Access Client
              </button>
            )}
            {/* <button className="accessClientBtn" onClick={() => handleAccessClient(data)}>Access Client</button> */}
            <div className="filterIcons">
              <Dropdown
                trigger={["click"]}
                overlay={
                  <Menu>
                    <Menu.Item>
                      <div
                        onClick={() => {
                          setModalVisible(true);
                          const clientData = data.client;
                          setFormData({
                            name: clientData.name || "",
                            username: clientData.userName || "",
                            email: clientData.email || "",
                            phone:
                              clientData.phoneNumber &&
                              clientData.phoneNumber.includes("+")
                                ? clientData.phoneNumber
                                : `+92 ${clientData.phoneNumber || ""}`,
                            zipCode: clientData.zipCode || "",
                            image: clientData.image || "",
                          });
                        }}
                      >
                        View
                      </div>
                    </Menu.Item>
                    {isShowClientBtn && (
                      <Menu.Item>
                        <div
                          onClick={() => {
                            deleteClient(data.client.id);
                          }}
                        >
                          Delete
                        </div>
                      </Menu.Item>
                    )}
                  </Menu>
                }
              >
                <a
                  className="ant-dropdown-link"
                  onClick={(e) => e.preventDefault()}
                  style={{ padding: "0px 1rem" }}
                >
                  <img src={menuIcon} height={15} width={4} alt="icon"></img>
                </a>
              </Dropdown>{" "}
            </div>
          </div>
        </div>
        {/* <Divider/> */}
      </div>
      <div className="clientDetailsCardFooter">
       {/* <div className="footerItems">
          <span className="footerItemTitle">Client Name</span>
          <span className="footerItemSubTitle">
            {data.client.name ? data.client.name : "N/A"}
          </span>
        </div>*/}
        <div className="footerItems">
          <div className="footerItemTitle">Spouse</div>
          <div
            className="footerItemSubTitle footerItemSubTitleTruncate"
            title={
              data &&
              Array.isArray(data.clientContacts) &&
              data.clientContacts.length > 0 &&
              data.clientContacts[0] &&
              data.clientContacts[0].name
                ? data.clientContacts[0].name
                : "N/A"
            }>
            {data &&
            Array.isArray(data.clientContacts) &&
            data.clientContacts.length > 0 &&
            data.clientContacts[0] &&
            data.clientContacts[0].name
              ? data.clientContacts[0].name
              : "N/A"}
          </div>
        </div>
        {/*<div className="footerItems">
          <div className="footerItemTitle">Net Worth</div>
          <div className="footerItemSubTitle">
            {data.netWorth
              ? `$${(+data.netWorth)
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
              : "N/A"}
          </div>
        </div>*/}
        <div className="footerItems">
          <div className="footerItemTitle">Investment Balance</div>
          <div className="footerItemSubTitle">
            {data.investmentBalance
              ? `$${(+data.investmentBalance)
                  .toFixed(2)
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
              : "N/A"}
          </div>
        </div>
        <div className="footerItems">
          <div className="footerItemTitle">Client Portal Access</div>
          <div className="footerItemSubTitle">
            {data.status === "Password Updated" ? "Yes" : "NO"}
          </div>
        </div>
        <div className="footerItems">
          <div className="footerItemTitle">Last Login</div>
          <div className="footerItemSubTitle">
            {data.client.lastLogin
              ? moment(data.client.lastLogin).local().format("MM/DD/YYYY")
              : "N/A"}
          </div>
        </div>
      </div>
      {isModalVisible && (
        <AddClientModal
          open={isModalVisible}
          onCancel={() => {
            setModalVisible(false);
          }}
          formData={formData}
          setFormData={setFormData}
          readOnly={true}
        />
      )}
    </div>
  );
};

export default ClientDetails;
